/* Confetti — reusable canvas-based burst.
   Usage:
     const c = new Confetti(canvasEl, { palette: [...], count: 90 });
     c.burst();           // optional: c.burst({ x, y }) for a custom origin
     c.stop();            // cancel mid-animation
     c.destroy();         // remove resize listener (call on teardown) */

(function () {
  if (window.Confetti) return;

  const DEFAULT_PALETTE = ['#004ebb', '#465e8b', '#FDE68A', '#99F6E4', '#E9D5FF', '#FECDD3', '#10B981', '#F59E0B', '#ba1a1a'];

  class Confetti {
    constructor(canvas, options = {}) {
      if (!canvas) throw new Error('Confetti requires a canvas element');
      this.canvas = canvas;
      this.ctx = canvas.getContext('2d');
      this.palette = options.palette || DEFAULT_PALETTE;
      this.count = options.count || 90;
      this.particles = [];
      this.animationId = null;
      this._onResize = this._resize.bind(this);
      window.addEventListener('resize', this._onResize);
      this._resize();
    }

    burst(origin) {
      this._resize();
      this.particles = [];
      const cx = origin && origin.x != null ? origin.x : this.canvas.width / 2;
      const cy = origin && origin.y != null ? origin.y : this.canvas.height / 2;
      for (let i = 0; i < this.count; i++) {
        const angle = Math.random() * Math.PI * 2;
        const force = Math.random() * 12 + 6;
        this.particles.push({
          x: cx,
          y: cy,
          z: 0.1,
          baseSize: Math.random() * 8 + 4,
          color: this.palette[Math.floor(Math.random() * this.palette.length)],
          shape: Math.random() > 0.5 ? 'square' : 'circle',
          vx: Math.cos(angle) * force,
          vy: Math.sin(angle) * force - 4,
          vz: Math.random() * 0.03 + 0.015,
          rotation: Math.random() * 360,
          rotationSpeed: (Math.random() - 0.5) * 15,
          gravity: 0.25,
          friction: 0.98,
          opacity: 0.5,
        });
      }
      if (!this.animationId) this._animate();
    }

    stop() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
      this.particles = [];
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }

    destroy() {
      this.stop();
      window.removeEventListener('resize', this._onResize);
    }

    _resize() {
      this.canvas.width = window.innerWidth;
      this.canvas.height = window.innerHeight;
    }

    _animate() {
      const ctx = this.ctx;
      const canvas = this.canvas;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      let alive = false;
      for (let i = this.particles.length - 1; i >= 0; i--) {
        const p = this.particles[i];
        p.vy += p.gravity;
        p.vx *= p.friction;
        p.x += p.vx;
        p.y += p.vy;
        p.z += p.vz;
        p.rotation += p.rotationSpeed;
        if (p.opacity < 1) p.opacity += 0.02;
        if (p.y > canvas.height * 0.9 || p.z > 2.5) p.opacity -= 0.05;

        if (p.opacity > 0) {
          alive = true;
          ctx.save();
          ctx.globalAlpha = Math.max(0, Math.min(1, p.opacity));
          ctx.translate(p.x, p.y);
          const scale = Math.max(0.1, p.z);
          ctx.scale(scale, scale);
          ctx.rotate((p.rotation * Math.PI) / 180);
          ctx.fillStyle = p.color;
          if (p.shape === 'square') {
            ctx.fillRect(-p.baseSize / 2, -p.baseSize / 2, p.baseSize, p.baseSize);
          } else {
            ctx.beginPath();
            ctx.arc(0, 0, p.baseSize / 2, 0, Math.PI * 2);
            ctx.fill();
          }
          ctx.restore();
        } else {
          this.particles.splice(i, 1);
        }
      }

      if (alive) {
        this.animationId = requestAnimationFrame(() => this._animate());
      } else {
        this.animationId = null;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    }
  }

  window.Confetti = Confetti;
})();
